import React from "react";
import { Container, Typography, Box, Divider } from "@mui/material";
import "./Cgu.css";
import Header from '../header/header';
import Footer from '../commun/Footer';

const PolitiqueConfidentialite = () => (

        <>

    < Header />
  <Container maxWidth="md" className="cgu-container">
    <Box py={5}>
      <Typography variant="h4" align="center" gutterBottom>
        POLITIQUE DE CONFIDENTIALITE (RGPD)
      </Typography>


      <Typography
        variant="subtitle2"
        align="center"
        className="cgu-date"
        gutterBottom
      >
        Dernière mise à jour : [18/09/2025]
      </Typography>

      <Divider className="cgu-divider" />

      <Typography variant="h6" gutterBottom>
      1. Données collectées
      </Typography>
      <Typography paragraph>
       Lors de l’utilisation de la Plateforme {" "}  
        <a
            href="https://cooptaleo.com/"
            style={{ textDecoration: "underline", color: "blue" }}
          >
           cooptaleo.com
        </a>, nous pouvons collecter :
      </Typography>
      <ul className="cgu-list">
        <li>Données d’identification : nom, prénom, adresse e-mail, numéro de téléphone ;</li>
        <li>Données professionnelles : CV, parcours, poste, rémunération, préférences contractuelles ;</li>
        <li>Données de navigation : adresse IP, pages visitées, actions effectuées sur le site (cookies).</li>
      </ul>
      <Typography paragraph>
      Ces données sont collectées via nos formulaires, l’espace utilisateur ou votre navigation.
      </Typography>

      <Typography variant="h6" gutterBottom>
      2. Finalités et bases légales
      </Typography>
      <Typography paragraph>
        Vos données sont utilisées pour :
      </Typography>
      <ul className="cgu-list">
        <li>Créer et gérer votre compte utilisateur (base légale : exécution du contrat) ;</li>
        <li>Mettre en relation entreprises, recruteurs et candidats (base légale : exécution du contrat) ;</li>
        <li>Envoyer des notifications liées à votre activité (base légale : exécution du contrat) ;</li>
        <li>Analyser l’audience du site et améliorer les services (base légale : intérêt légitime) ;</li>
        <li>Proposer des actions marketing ciblées (base légale : consentement).</li>
      </ul>

      <Typography variant="h6" gutterBottom>
        3. Partage des données
      </Typography>
      <Typography paragraph>
      Vos données peuvent être transmises à :
      </Typography>
      <ul className="cgu-list">
        <li>Entreprises clientes, pour l’évaluation des candidats ;</li>
        <li>Recruteurs indépendants, pour la mise en relation avec les entreprises ;</li>
        <li>Prestataires techniques (hébergement, outils de messagerie, analytics).</li>
      </ul>
      <Typography paragraph>
       Ces tiers agissent en qualité de sous-traitants au sens du RGPD et s’engagent à respecter la confidentialité et la sécurité de vos données.
      </Typography>

      <Typography variant="h6" gutterBottom>
        4. Hébergement et transferts hors UE
      </Typography>
      <Typography paragraph>
       Les données sont hébergées chez OVH, sur des serveurs situés en Europe.
      </Typography>
      <Typography paragraph>
       En cas de transfert de données vers un pays hors Union européenne (par exemple via des outils publicitaires ou emailing), nous veillons à ce que des garanties appropriées soient mises en place (clauses contractuelles types validées par la Commission européenne).
      </Typography>

      <Typography variant="h6" gutterBottom>
      5. Durée de conservation
      </Typography>
      <Typography paragraph>
      Vos données sont conservées jusqu’à la suppression de votre compte par vos soins ou 3 ans après la dernière activité sur votre compte.
      </Typography>

      <Typography variant="h6" gutterBottom>
      6. Sécurité
      </Typography>
      <Typography paragraph>
       Nous mettons en œuvre toutes les mesures techniques et organisationnelles nécessaires pour assurer la sécurité et la confidentialité de vos données personnelles, afin d’éviter leur perte, altération ou accès non autorisé.
      </Typography>

      <Typography variant="h6" gutterBottom>
         7. Vos droits
      </Typography>
      <Typography paragraph>
      Conformément à la réglementation applicable, vous disposez des droits suivants :
      </Typography>
      <ul className="cgu-list">
        <li>droit d’accès, de rectification, d’opposition, d’effacement, de limitation du traitement ;</li>
        <li>droit à la portabilité ;</li>
        <li>droit de retirer votre consentement à tout moment pour les traitements basés sur le consentement (ex. cookies marketing) ;</li>
        <li>droit d’introduire une réclamation auprès de la CNIL.</li>
      </ul>
      <Typography paragraph>
        Vous pouvez exercer vos droits en écrivant à : {" "}
        <a
          href="mailto:contact@cooptaleo.com"
          style={{ textDecoration: "underline", color: "blue" }}
        >
          contact@cooptaleo.com
        </a>{" "} (ou par courrier à l’adresse de l’Éditeur).
      </Typography>

      <Typography variant="h6" gutterBottom>
      8. Cookies
      </Typography>
      <Typography paragraph>
      Pour plus d’informations sur l’utilisation des cookies, consultez notre Politique de cookies.
      </Typography>

      <Typography variant="h6" gutterBottom>
        9. Responsable du traitement
      </Typography>
      <Typography paragraph>
        Le responsable du traitement est :<br/>
        CIT MENA INFORMATION TECHNOLOGY CONSULTANCY<br/>
        Office F1 – 261 Hor Al Anz – Dubai – UAE<br/>
        {" "}
        <a
          href="mailto:contact@cooptaleo.com"
          style={{ textDecoration: "underline", color: "blue" }}
        >
          contact@cooptaleo.com
        </a>{" "}
      </Typography>
    </Box>
  </Container>
   <Footer />

  </>
);

export default PolitiqueConfidentialite;
